export const changePlan = async (endpoint_url, data, csrf_token) => {
    return fetch(`${endpoint_url}/customers/bulk-plan-change/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrf_token,
        },
        body: JSON.stringify(data),
    });
};
